import React, { useEffect, useRef, useState } from 'react';
import {
  MdCalendarMonth,
  MdCheck,
  MdFilterList,
  MdGroups,
  MdKeyboardArrowDown,
  MdMenu,
  MdNotificationsNone,
  MdOutlineRefresh,
  MdSearch,
  MdTune,
  MdViewCompact,
} from 'react-icons/md';

function NewTopHeader({
  boards,
  selectedBoardId,
  onBoardChange,
  searchValue,
  onSearchChange,
  onSearch,
  searchScope,
  onSearchScopeChange,
  searchType,
  onSearchTypeChange,
  searchTypes,
  onFilters,
  onPeople,
  onDates,
  onNotifications,
  notificationCount,
  onCalendar,
  onReload,
  density,
  onDensityChange,
  activeFilterCount,
  onOpenNavigation,
}) {
  const [boardMenuOpen, setBoardMenuOpen] = useState(false);
  const boardPickerRef = useRef(null);
  const selectedBoard = boards.find((board) => String(board.id) === String(selectedBoardId));

  useEffect(() => {
    if (!boardMenuOpen) return undefined;

    const closeBoardMenu = (event) => {
      if (!boardPickerRef.current?.contains(event.target)) setBoardMenuOpen(false);
    };
    const closeBoardMenuOnEscape = (event) => {
      if (event.key === 'Escape') setBoardMenuOpen(false);
    };

    document.addEventListener('mousedown', closeBoardMenu);
    document.addEventListener('keydown', closeBoardMenuOnEscape);
    return () => {
      document.removeEventListener('mousedown', closeBoardMenu);
      document.removeEventListener('keydown', closeBoardMenuOnEscape);
    };
  }, [boardMenuOpen]);

  return (
    <header className="new-home-topbar">
      <div className="new-home-topbar-title">
        <button type="button" className="new-home-icon-button new-home-mobile-menu-button" onClick={onOpenNavigation} aria-label="Abrir menu de navegação" title="Abrir menu">
          <MdMenu aria-hidden="true" />
        </button>
        <div className="new-home-topbar-title-copy">
          <span className="new-home-eyebrow">Pipeline comercial</span>
          <div className="new-home-board-picker" ref={boardPickerRef}>
            <button className="new-home-board-picker-button" type="button" onClick={() => setBoardMenuOpen((value) => !value)} aria-label="Selecionar pipeline comercial" aria-haspopup="listbox" aria-expanded={boardMenuOpen}>
              <span>{selectedBoard?.name || 'Selecionar pipeline'}</span><MdKeyboardArrowDown />
            </button>
            <span className="new-home-live-dot" aria-label="Dados sincronizados" title="Dados sincronizados" />
            {boardMenuOpen && (
              <div className="new-home-board-menu" role="listbox" aria-label="Pipelines comerciais">
                <span className="new-home-board-menu-title">Pipelines comerciais</span>
                {boards.map((board) => (
                  <button
                    key={board.id}
                    type="button"
                    role="option"
                    aria-selected={String(board.id) === String(selectedBoardId)}
                    className={String(board.id) === String(selectedBoardId) ? 'is-selected' : ''}
                    onClick={() => { onBoardChange(String(board.id)); setBoardMenuOpen(false); }}
                  >
                    <span>{board.name}</span>{String(board.id) === String(selectedBoardId) && <MdCheck />}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <form className="new-home-global-search" onSubmit={(event) => { event.preventDefault(); onSearch(); }} role="search">
        <MdSearch aria-hidden="true" />
        <select
          className="new-home-search-scope"
          value={searchScope}
          onChange={(event) => onSearchScopeChange(event.target.value)}
          aria-label="Alcance da busca"
          title="Alcance da busca"
        >
          <option value="board">Quadro</option>
          <option value="global">Todos</option>
        </select>
        <input
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
          placeholder={searchScope === 'board' ? 'Buscar neste quadro' : 'Buscar em todos os cards'}
          aria-label={searchScope === 'board' ? 'Pesquisar cards neste quadro' : 'Pesquisar em todos os cards'}
        />
        <select
          className="new-home-search-type"
          value={searchType}
          onChange={(event) => onSearchTypeChange(event.target.value)}
          aria-label="Campo da busca"
          title="Campo da busca"
        >
          {searchTypes.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </select>
        <button type="submit">Buscar</button>
      </form>

      <div className="new-home-top-actions">
        <button className={`new-home-action-button ${activeFilterCount ? 'is-active' : ''}`} onClick={onFilters} title="Filtros" aria-label={`Filtros${activeFilterCount ? `, ${activeFilterCount} ativos` : ''}`}>
          <MdFilterList /><span>Filtros</span>{activeFilterCount > 0 && <b>{activeFilterCount}</b>}
        </button>
        <button className="new-home-icon-button" onClick={onPeople} title="Equipe" aria-label="Filtrar equipe"><MdGroups /></button>
        <button className="new-home-icon-button" onClick={onDates} title="Período" aria-label="Filtrar período"><MdCalendarMonth /></button>
        <button className="new-home-icon-button" onClick={onDensityChange} title={`Densidade ${density}`} aria-label="Alterar densidade dos cards"><MdViewCompact /></button>
        <button className="new-home-icon-button" onClick={onReload} title="Atualizar" aria-label="Atualizar cards"><MdOutlineRefresh /></button>
        <button className="new-home-icon-button" onClick={onCalendar} title="Calendário" aria-label="Abrir calendário"><MdTune /></button>
        <button className="new-home-icon-button new-home-notification-button" onClick={onNotifications} title="Notificações" aria-label="Abrir notificações">
          <MdNotificationsNone />{notificationCount > 0 && <span>{notificationCount > 99 ? '99+' : notificationCount}</span>}
        </button>
      </div>
    </header>
  );
}

export default React.memo(NewTopHeader);
